import {langCode} from '@/helpers/localePrefix'

export default {
  data()
  {
    return {
      lang: this.getCurrentLanguage()
    }
  },
  methods: {
    getCurrentLanguage()
    {
      return this.$i18n ? langCode(this.$i18n.locale) : 'en'
    }
  }
}
